import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {ReservationService} from "app/services";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {AddPassengerTypes} from "app/types/service-types/ReservationTypes";
import {filterSchedules} from "./filter-schedules.slice";
import store from "../../../store";

interface AddPassengerParams {
  id: string;
  body: AddPassengerTypes;
  onSuccess?: Function;
  onError?: Function;
}

export const addPassenger =
    (params: AddPassengerParams) => async (dispatch: Dispatch) => {
      const filters = store.getState().schedules.filterSchedules;
      try {
        dispatch(setLoading(true));
        const response = await ReservationService.addPassenger(
            params.id,
            params.body
        );

        if (response.status >= 200 || response.status < 300) {
          dispatch(setSuccess(true));
          dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Passenger added successfully!' : 'Pasagjeri u shtua me sukses!'));
          if (params.onSuccess) params.onSuccess();
          dispatch(setError(""));
          // @ts-ignore
          dispatch(
              // @ts-ignore
              filterSchedules({
                ...filters,
                page: 0,
              })
          );
        }
        dispatch(setLoading(false));
      } catch (err) {
        dispatch(setLoading(false));
        dispatch(errorMsg(err.data.message));
        if (params.onError) params.onError();
        dispatch(setError(err.data.message));
      }
    };

interface AddPassengerSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: AddPassengerSlice = {
  error: "",
  success: false,
  loading: false,
};

const stateSlice = createSlice({
  name: "schedules/addPassenger ",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;
